import RIEBase from 'components/core/editable/RIEBase';

/**
 * Modified from https://github.com/kaivi/riek, v1.1.0
 */
export default class RIEInput extends RIEBase {

}



// WEBPACK FOOTER //
// ./src/components/core/editable/RIEInput.js